module.exports = __webpack_public_path__ + "static/img/no-resource-data.09e255cb.png";